import useMisclaims from './useMisclaims';
import { buildRepairs } from './repairs';
import type { AssignmentRow } from './useAssignmentRows';
import type { MatchPayload } from './useCourseMatch';

/**
 * The per-row repairs, or null until all three sources are in — the table filters on them, and a
 * half-built map would show rows jumping in and out as each request lands. A source that answered with
 * an error, or failed outright, counts as in: otherwise "checking" never ends.
 */
const useRepairs = (
  stafferId: string,
  assignments: AssignmentRow[] | undefined,
  match: MatchPayload | undefined,
  enabled: boolean,
) => {
  const gradebook = useMisclaims(stafferId, enabled);
  const matched = match?.rows != null || match?.error != null;
  const ready = assignments != null && matched && (gradebook.data != null || gradebook.isError);

  return {
    checking: enabled && !ready,
    repairs: ready
      ? buildRepairs(assignments, match?.rows ?? [], gradebook.data?.rows ?? [], {
        attachable: gradebook.data?.attachable,
        classes: match?.class_map?.classes,
        courseTitles: match?.course_titles,
      })
      : null,
  };
};

export default useRepairs;
